<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
      <v-data-table
        :headers="headers"
        fixed-header
        height="50vh"
        :items="withDrawals"
        :loading="loading"
        :search="search"
        :sort-desc="[false, true]"
        :single-select="false"
        multi-sort
        v-model="selected"
        dark
        dense
        class="table"
        item-key="id"
        scope="props"
        show-select
      >
        <template v-slot:top>
          <v-toolbar flat dark rounded>
            <v-toolbar-title>Withdrawals</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <export-excel :data="withDrawals" name="withDrawals">
              <v-btn color="primary"><v-icon color="white">mdi-file-download</v-icon></v-btn>
            </export-excel>
          </v-toolbar>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span v-if="item.status === 'failed'" @click="openBankingErrorsDialog(item.bankingErrors)"><a>failed</a></span>
          <span v-if="item.status !== 'failed'">{{ item.status }}</span>
           <v-dialog v-model="bankingErrorsDialog._enabled" width="350" :retain-focus="false">
            <v-container class="grey darken-4 px-10">
              <v-row class="flex-column mb-3">
                <div class="d-flex mt-3"><h4 class="mx-auto gold">Errors</h4></div>
                <div class="d-flex mt-5" v-for="(error, i) in item.bankingErrors" :key="i">
                  {{ `${i+1} - ${error}`}}
                </div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.unlock`]="{ item }">
          <span @click="openUnlockDialog(item.unlock)"><a>Open</a></span>
           <v-dialog v-model="unlockDialog._enabled" width="350" :retain-focus="false">
            <v-container class="grey darken-4 px-10">
              <v-row class="flex-column mb-3" v-if="item && item.unlock">
                <div class="d-flex mt-3"><h2 class="mx-auto gold">Unlock</h2></div>
                <div v-if="item.unlock.code" class="d-flex">Code: <span class="ml-auto gold">{{  item.unlock.code }}</span></div>
                <div v-if="item.unlock.validUntil" class="d-flex">Valid Until: <span class="ml-auto gold">{{ item.unlock.validUntil | date }}</span></div>
                <div v-if="item.unlock.createdAt" class="d-flex">Created At: <span class="ml-auto gold">{{ item.createdAt | date }}</span></div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.details.segmentReport`]="{ item }">
          <span v-if="item.details" @click="openSegmentReportDialog(item.details.segmentReport)"><a>Open</a></span>
           <v-dialog v-if="item.details && item.details.segmentReport" v-model="segmentReportDialog._enabled" width="350" :retain-focus="false">
            <v-card>
              <v-container v-if="segmentReportDialog.segmentReport">
                <v-row class="flex-column mb-4" v-for="segmentReport in Object.entries(segmentReportDialog.segmentReport)" :key="segmentReport[0]" dense>
                  <span class="mx-auto mt-5 mb-2">Segmento {{ segmentReport[0].charAt(0).toUpperCase() + segmentReport[0].slice(1) }}</span>
                  <v-row class="flex-column mb-3" v-for="list of segmentReport[1].lists" :key="list.id" dense>
                    <div class="d-flex">
                      Lista: <span class="mb-2 ml-auto gold list-title"><a :href="'https://sites.mimon.com.br/' + list.slug" target="_blank">{{ list.title }}</a></span>
                    </div>
                    <div class="d-flex">Valor vendido: <span class="mb-2 ml-auto gold">{{ list.soldAmount | brl }}</span></div>
                    <div class="d-flex">Taxa aplicada: <span class="mb-2 ml-auto gold">{{ segmentReport[1].tax }}%</span></div>
                    <div class="d-flex">Valor com taxa:<span class="mb-2 ml-auto gold">{{ list.soldAmount - list.soldAmount * (segmentReport[1].tax / 100) | brl }}</span></div>
                  </v-row>
                </v-row>
                <hr/>
                <v-row class="flex-column mt-5 mb-3">
                  <div class="d-flex">Total com taxa{{ item.details.segmentReport.length > 1 ? 's' : '' }}
                    <span class="ml-auto gold">{{ item.details.receivable + item.details.cost | brl }}</span>
                  </div>
                  <div class="d-flex">Total à receber: <span class="mb-2 ml-auto gold">{{ item.details.receivable | brl }}</span></div>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-if="item" :disabled="item.status !== 'processing'" class="mr-2" small @click="rejectWithDraw(item)">mdi-close</v-icon>
          <v-icon v-if="item" :disabled="item.status !== 'processing'" class="mr-2" small @click="unlockWithDraw(item, 'manual')">mdi-lock-open-variant-outline</v-icon>
          <v-icon v-if="item" :disabled="item.status !== 'processing'" small @click="unlockWithDraw(item, 'api')">mdi-lock-open-variant</v-icon>
        </template>
         <template v-slot:[`item.link.userPhone`]="{ item }">
          <span>+{{ item.link.userPhone }}</span>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          <span>{{ item.createdAt | date }}</span>
        </template>
        <template v-slot:[`item.details.amount`]="{ item }">
          <span v-if="item && item.details">{{ item.details.amount | brl }}</span>
        </template>
        <template v-slot:[`item.details.cost`]="{ item }">
          <span v-if="item && item.details">{{ item.details.cost | brl }}</span>
        </template>
        <template v-slot:[`item.details.tax`]="{ item }">
          <span v-if="item && item.details">{{ item.details.tax }}%</span>
        </template>
        <template v-slot:[`item.details.receivable`]="{ item }">
          <span v-if="item && item.details">{{ item.details.receivable | brl }}</span>
        </template>
      </v-data-table>
      </v-row>
      <v-row align="center" justify="center">
      <div :class="`d-flex flex-wrap justify-end my-6 btn-ctn table`">
        <v-btn class="table-action mr-5 my-1" color="purple" @click="rejectWithDrawals()"> <!-- // => padronize to english -->
          <v-icon>mdi-close</v-icon>
          Recusar
        </v-btn>
        <v-btn class="table-action mr-5 my-1" color="green" @click="unlockWithDrawals('manual')"> <!-- // => padronize to english -->
          <v-icon>mdi-lock-open-variant-outline</v-icon>
          <span>Liberar (Manual)</span>
        </v-btn>
        <v-btn class="table-action my-1" color="green" @click="unlockWithDrawals('api')"> <!-- // => padronize to english -->
          <v-icon>mdi-lock-open-variant</v-icon>
          Liberar
        </v-btn>
      </div>
    </v-row>
    </v-container>
  </v-main>
</template>

<style lang="scss">
  .table {
    width: 85%;
    .search {
      margin-right: 25px;
      max-width: 300px;
    }
  }

  th {
    span { font-size: 15px; }
    color: gold !important;
  }

  .v-dialog {
    box-shadow: none !important;
    .list-title { max-width: 275px; }

    .v-card { padding: 0 10px; }
  }

  .large { min-width: 125px; }
  .gold { color: gold; }
  .pointer { cursor: pointer; }
</style>

<script>
/* eslint-disable */
import { upperCaseFirstLetter } from '@/utils/strings'
import { formatDate } from '@/utils/date'

const translatedTableTitles = {}
const translatedTableFields = {}
const translatedGeneralWordsAndPhrases = {}

const hiddenTableColumns = ['id', 'details', 'bankAccount',  'transactions', 'withDraws', 'link', 'transactionsID', 'bankingErrors']

export default {
  name: 'WithDrawals',
  data () {
    return {
      loading: true,
      search: '',
      headers: [],
      selected: [],
      withDrawals: [],
      bankingErrorsDialog: {
        _enabled: false,
        bankingErrors: null
      },
      unlockDialog: {
        _enabled: false,
        unlock: []
      },
      segmentReportDialog: {
        _enabled: false,
        segmentReport: null
      },
    }
  },
  mounted () {
    let headerCreated = false

    this.$axios.get('wallet/search', {
      data: { isEmpty: false }
    }).then(res => {
      res.data.forEach(wallet => {
        if (!headerCreated) {
          for (const key of Object.entries(wallet)) {
            if (key[0] === 'link')
              this.headers.push(
                { text: 'User ID', value: 'userID', align: ' d-none' },
                { text: 'User Name', value: 'userName'},
                { text: 'User Phone', value: 'userPhone'},
                { text: 'User Email', value: 'userEmail'},
              )
            

            if (key[0] === 'withDraws' && key[0].length > 0) 
              for (const _key of Object.entries(wallet.withDraws[0])) {
                if (_key[0] === 'details') {
                  this.headers.push(
                    { text: 'Amount', value: 'details.amount' },
                    { text: 'Cost', value: 'details.cost' },
                    { text: 'Tax', value: 'details.segmentReport' },
                    { text: 'Receivable', value: 'details.receivable' }
                  )
                  continue
                }

                this.headers.push({ text: upperCaseFirstLetter(_key[0]), value: _key[0], class: 'large', align: hiddenTableColumns.includes(_key[0]) ? ' d-none' : '' })
              }
            
            this.headers.push({ text: upperCaseFirstLetter(key[0]), value: key[0], class: 'large', align: hiddenTableColumns.includes(key[0]) ? ' d-none' : '' })
          }
          
          this.headers.push({ text: 'Actions', value: 'actions', sortable: false, width: '13%' })
          headerCreated = true;
        }

        if (!wallet.withDraws.length)
          return

        wallet.withDraws.forEach(withDraw => {
          let mergedWallet = { 
            walletID: wallet.id,
            ...wallet,          
            ...withDraw,                        
            stateArrayPos: this.withDrawals.length === 0 ? 0 : this.withDrawals.length-1 
          } 
          
          if (!withDraw.details?.segmentReport) {
            if (!withDraw.details)
              withDraw.details = {}
            
            withDraw.details.segmentReport = {}
          }

          for (const key of Object.entries(wallet.link)) 
            mergedWallet = { ...mergedWallet, [key[0]]: key[1]}
          
          this.withDrawals.push(mergedWallet)
        });
      })
      
      console.log(this.withDrawals)
      this.loading = false
    })
    .catch(err => console.log(err))
  },
  computed: {
    //formTitle () { return this.configDialog.itemIndex === -1 ? 'Include Config' : 'Edit Config' }
  },
  methods: {
    openUnlockDialog (unlock) {
      this.unlockDialog = { _enabled: true, unlock }
    },
    openSegmentReportDialog (segmentReport) {
      console.log(segmentReport)
      this.segmentReportDialog = { _enabled: true, segmentReport }
    },
    openBankingErrorsDialog (bankingErrors) {
      this.bankingErrorsDialog = {_enabled: true, bankingErrors }
    },
    requestBankingTransfer (withDraw, operationType) { 
      return this.$axios.post('banking', {
        operation: {
          type: `${operationType}_transfer`,
        },
        link: {
          recipientID: withDraw.link.userID,
          walletID: withDraw.walletID
        }
      })
    },
    requestWithDrawRejection (withDrawIDs) {
      return this.$axios.instance.post('wallet/withdraw/reject', withDrawIDs)
    },
    async unlockWithDraw (withDraw, operationType) {
      if (!['processing'].includes(withDraw.status)) {
        alert('Untransferable withdraw')
        return
      }

      await this.requestBankingTransfer(withDraw, operationType)
        .then(res => {
          if (res.status !== 201) {
            alert('Falha ao transferir')
            return
          }
        
          if (operationType === 'manual') 
            this.withDrawals[withDraw.stateArrayPos].status = 'transfered'
          
          alert('ok')
        })
        .catch(err => { 
          console.log(err)
          alert('Falha na solicitação da transferência')
        })
    },
    unlockWithDrawals (operationType) {
      if(this.selected.length === 0) {
        alert('No withdraw has been selected')
        return
      }

      const failedTransfers = []
      this.selected.forEach(withDraw => {
       if (!['processing'].includes(withDraw.status)) {
          withDraw.failedReason = 'Untransferable withdraw due its status'
          failedTransfers.push(withDraw)
          return
        }

        this.requestBankingTransfer(withDraw, operationType).then(res => {
          if (res.status !== 201) {
            failedTransfers.push(withDraw)
          }

          if (operationType === 'manual') 
            this.withDrawals[withDraw.stateArrayPos].status = 'transfered'
        })
      })

      if (failedTransfers.length > 0) {
        alert(`As seguintes transferências falharam: \n
          ${failedTransfers.map(failedTransfer => `          
            -------------------------------------
            ${failedTransfer.failedReason || ''}
            ${this.$options.filters.brl(failedTransfer.details.receivable)} 
            ${failedTransfer.userName}
            ${failedTransfer.userEmail}
            ${this.$options.filters.date(failedTransfer.createdAt)}
            -------------------------------------
            \n\n\n
          `)}`
        )
        return
      }
      alert('ok')
    },
    rejectWithDraw (withDraw) {
      this.requestWithDrawRejection([ withDraw.id ])
        .then(() => {
          this.withDrawals[withDraw.stateArrayPos].status = 'rejected'
          alert('ok')
        })
        .catch(() => alert('Falha ao rejeitar a solicitação'))
    },
    rejectWithDrawals () {
       if(this.selected.length === 0) {
        alert('No withdraw has been selected')
        return
      }

      const withDrawals = []
      this.selected.forEach(withDraw => {
        if (withDraw.status === 'processing') 
          withDrawals.push({
            id: withDraw.id,
            stateArrayPos: withDraw.stateArrayPos
          })
      })

      this.requestWithDrawRejection(withDrawals.map(withDraw => withDraw.id))
        .then(() => {
          withDrawals.forEach(withDraw => {
            this.withDrawals[withDraw.stateArrayPos].status = 'rejected'
          })
          
          alert('ok')
        })
        .catch(() => alert('Falha ao rejeitar as solicitações selecionadas'))
    },
    translateTableTitle (word) { return (word in translatedTableTitles) ? translatedTableTitles[word] : word },
    translateTableField (word) { return (word in translatedTableFields) ? translatedTableFields[word] : word },
    translateGeneralWordsAndPhrases (expression) { return (expression in translatedGeneralWordsAndPhrases) ? translatedGeneralWordsAndPhrases[expression] : expression },
    formatDate(date) { return formatDate(date) }    
  },
}
</script>